export enum AccountType {
  property_manager = 'property_manager',
  home_owner = 'home_owner',
  resident = 'resident',
}
